import { createFileRoute, Outlet } from "@tanstack/react-router";
import { z } from "zod";

import { NavStackProvider } from "@/utils/useNavStack";

export const Route = createFileRoute("/_auth/_app/accessions_/$id")({
  parseParams: (params) => {
    return { id: z.coerce.number().parse(params.id) };
  },
  component: AccessionDetailRoot,
});

function AccessionDetailRoot() {
  return (
    <NavStackProvider label="Accessions" href={{ to: "/accessions" }}>
      <Outlet />
    </NavStackProvider>
  );
}
